<template>
    <div role="dialog">
        <transition name="modal-fade">
            <div v-show="show" class="modal-container modal-container--opacity-70 show" v-bind:id="id" v-on:click.prevent.stop="close">
                <a v-if="showCloseButton" v-on:click.prevent="close" class="modal-close close i-container p-2 rounded-xlarge c-lighter-bg i-filled-dark" href="#close-modal">
                    <!-- /icons/close.svg -->
                    <svg class="icon icon-dark i-size-small" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g class="icon"><path d="M19 3.586L3.586 19 5 20.414 20.414 5z"/><path d="M20.414 19L5 3.586 3.586 5 19 20.414z"/></g></svg>
                </a>
                <div class="modal p-t-5 p-b-5 c-bright-bg box-large panel">
                    <div class="modal-content m-b-0 h-100">
                        <div class="row row-center row-middle row-tall">
                            <div class="small-12 columns">
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    export default {
        props: {
            id: {
                type: String
            },
            title: {
                type: String
            },
            showCloseButton: {
                type: Boolean,
                default: true
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            show(value) {
                if (value === true) {
                    if ( ! document.body.classList.contains('modaled')) {
                        document.body.classList.add('modaled');
                    }
                } else {
                    if (document.body.classList.contains('modaled')) {
                        document.body.classList.remove('modaled');
                    }
                }
            }
        },
        methods: {
            close() {
                this.$emit('update:show', false);
                this.$parent.$emit('close');

                if (document.body.classList.contains('modaled')) {
                    document.body.classList.remove('modaled');
                }
            }
        },
        mounted() {
            if (this.$parent.show === true && ! document.body.classList.contains('modaled')) {
                document.body.classList.add('modaled');
            }
        }
    }
</script>